import PropTypes from 'prop-types';
import moment from 'moment';

const DateFormatter = (props) => <>{props.date && moment(props.date).format(props.format)}</>;

DateFormatter.propTypes = {
  date: PropTypes.string.isRequired,
  format: PropTypes.string,
};

DateFormatter.defaultProps = {
  format: 'YYYY-MM-DD',
};

export default DateFormatter;
